import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Outlet, RouteObject } from 'react-router';

import { Route as CustomersOverviewRoute } from './_index';
import { Route as HoldingsRoute } from './holdings/_index';
import { Route as InfoRoute } from './info/_index';
import { Route as SummaryRoute } from './summary/_index';

// Exports
export const Router: RouteObject = {
  element: (
    <Flex direction="column" padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}>
      <Outlet />
    </Flex>
  ),
  // Relative to /valley-bank/customers/*
  children: [
    { index: true, element: <CustomersOverviewRoute /> },
    { path: 'summary', element: <SummaryRoute /> },
    { path: 'holdings', element: <HoldingsRoute /> },
    { path: 'info', element: <InfoRoute /> },
  ],
};
